const conf = require("../conf.json");
const server = process.env.NODE_ENV == "production" ? conf.server : conf["server"]

const accUrl = (service) => API.exchangeUrl + service;
const exURL = (service) => API.exchangeUrl + service;
const mkURL = (service) => API.marketUrl + service;

let API = {
    // exchangeUrl: "http://192.168.1.70:18081/",
    // wsExchangeUrl: "http://192.168.1.70:18081/",
    // wsMarketUrl: "http://192.168.1.70:18082/",
    // marketUrl: "http://192.168.1.70:18082/",


    exchangeUrl: server.exchange,
    wsExchangeUrl: server.exchange,
    wsMarketUrl: server.market,
    marketUrl: server.market,

    wsExchangeEndpoint: "exchange-ws",
    wsMarketEndpoint: "market-ws",
    walletService: "wallet/", //在线钱包
    defiService: "defi/", //本地钱包
    accountService: "account/",
    exchangeService: "exchange/",

    marketService: "market/",
    market_ws_topics: ['/topic/market/trade', '/topic/market/thumb', '/topic/market/plate'],

    //websocket endpoint url
    ws_market_url: () => API.wsMarketUrl + API.wsMarketEndpoint,
    ws_exchange_url: () => API.wsExchangeUrl + API.wsExchangeEndpoint,

    //wallet api
    wallet_balance: (id) => {
        let accId = id;
        if (typeof id == 'function') {
            accId = id();
        }
        return exURL(API.walletService) + "balance/" + accId;
    },

    /**
     * 用户请求钱包划转
     * 
     * params: {
     * 
     *      accountId,
     *      from    {WalletAccount} ,
     *      to      {WalletAccount} ,
     *      type    {CoinType} ,
     *      value   {BugNumber}
     * }
     * 
     * @param params 
     * @returns 
     */
    wallet_transfer: (params) => paramsToURL(exURL(API.walletService) + "userTransfer/", params),

    /**
     * 用户请求钱包地址列表
     * @returns 
     */
    wallet_address_list: () => exURL(API.walletService) + "address_get",

    /**
     * 用户请求添加或者更新钱包地址
     * POST请求
     * @returns 
     */
    wallet_address_add: () => exURL(API.walletService) + "address_update",

    /**
     * 用户请求初始化tx
     * POST
     * @returns 
     */
    wallet_trans_fee: () => exURL(API.walletService) + "trans/fee",

    /**
     * 用户请求执行tx
     * POST
     * @returns 
     */
    wallet_trans_do: () => exURL(API.walletService) + "trans/do",
    /**
     * 用户请求更新tx状态
     * POST
     * @returns 
     */
    wallet_trans_update: () => exURL(API.walletService) + "trans/update",

    wallet_trans_history: (transferNet) => paramsToURL(exURL(API.walletService) + "trans/history", { transferNet }),

    //account api
    account_login: (params) => paramsToURL(accUrl(API.accountService) + "loginRequest", params),

    account_reg: (params) => paramsToURL(accUrl(API.accountService) + "registerRequest", params),

    account_login_check: (params) => paramsToURL(accUrl(API.accountService) + "loginCheck", params),

    account_verify_code: (params) => paramsToURL(accUrl(API.accountService) + "verifyCode", params),

    account_resend_code: (params) => paramsToURL(accUrl(API.accountService) + "resendCode", params),

    account_get_profile: (params) => paramsToURL(accUrl(API.accountService) + "getProfile", params),

    account_get_wallet: () => paramsToURL(accUrl(API.accountService) + "getWalletDetail"),

    //defi api
    defi_token_list: () => paramsToURL(exURL(API.defiService) + "tokenList/"),

    //exchange api
    exchange_symbolInfo: () => exURL(API.exchangeService) + "symbolInfo",

    /**
     * 用户请求下单
     * 
     * params: {
     * 
     *      account,
     *      type        {GTC or IOC},
     *      action      {BID or ASK},
     *      symbolId,
     *      price,
     *      amount
     * }
     * 
     * @param  params 
     * @returns 
     */
    exchange_placeOrder: (params) => paramsToURL(exURL(API.exchangeService) + "placeOrder/", params),

    /**
     * 用户取消订单
     * 
     * params:{
     *  
     *      account,
     *      orderId,
     *      symbolId
     * }
     * 
     * @param  params 
     * @returns 
     */
    exchange_cancelOrder: (params) => paramsToURL(exURL(API.exchangeService) + "cancelOrder/", params),

    /**
     * 获取用户当前委托订单
     * @param {long} userId 
     * @param {int} symbol 
     * @returns 
     */
    exchange_tradingOrders: (userId, symbol = -1) => exURL(API.exchangeService) + `userTradingOrder/${userId}?symbol=${symbol}`,

    /**
     *  查询用户已成交或撤销的委托订单
     * 
     * params {
     * 
     *      symbolId: 交易对Id,-1表示不限,
     *      orderAction: 0=ask 1=bid -1表示不限制
     *      includeCanceld: 是否包含已撤销的订单
     *      scope: 查询范围 SearchTimeScope
     * }
     * 
     * @param {long} userId
     * @param   params
     */
    exchange_searchOrder: (userId, params) => paramsToURL(exURL(API.exchangeService) + `searchOrder/${userId}`, params),

    /**
     * 获取订单的交易详情
     * @param {long} userId 
     * @param {long} orderId 
     * @returns 
     */
    exchange_getOrderDetail: (userId, orderId) => exURL(API.exchangeService) + `orderDetail/${userId}?orderId=${orderId}`,

    //market api
    market_coinList: () => mkURL(API.marketService) + "coinDataList",
    market_quotePriceMap: (currency) => mkURL(API.marketService) + "quotePriceMap/" + currency,
    market_symbolPlate: (symbol, priceStep) => mkURL(API.marketService) + "symbolPlate/" + symbol + "?priceStep=" + priceStep,
    market_recentTrade: (symbol) => mkURL(API.marketService) + "symbolRecentTrade/" + symbol,
    market_klineHistory: (symbolId, rangeField) => mkURL(API.marketService) + "kline/" + symbolId + "/" + rangeField,
}


function paramsToURL(url, params) {
    let ret = url;
    let p = "";
    for (const k in params) {
        // if (Object.hasOwnProperty.call(params, key)) {
        const v = params[k];
        p = `${p}${k}=${v}&`;
    }
    if (p != "") {
        ret = ret + "?" + p;
    }
    return ret;
}


export default API;